/* global femcare, shuffle */

femcare.product.productSort = {
    init: function() {
      this.sortingInitialized = false;
      this.addedReviewsData = false;
      this.initShuffle;

      this.initMembers();
      this.initOpenSort();
      this.initCloseSort();
    },

    initMembers: function(){
      this.sortingContainer = $('.product-list__container');
      this.$productList = $('.product-list');
      this.initSortButton = $('.init-sort');
      this.$sortOverlay = $('.product-sort__overlay');
      this.$sortOptions = this.$sortOverlay.find('.product-sort__sort-options')
    },

    initOpenSort: function() {
      this.initSortButton.click( function() {
          if (!this.$sortOverlay.hasClass('product-sort__overlay--visible')) {
            this.$sortOverlay.toggleClass('product-sort__overlay--visible');
            $('.product-filter--page-overlay').show();
            this.initSort();
              if(!this.addedReviewsData) {
                this.addReviews();
              }
          }
      }.bind(this));
  },

  initCloseSort: function(){
    $('.product-filter--page-overlay, .product-sort__overlay-close').click(function(){
      if(this.$sortOverlay.hasClass('product-sort__overlay--visible')){
        this.$sortOverlay.toggleClass('product-sort__overlay--visible');
        $('.product-filter--page-overlay').hide();
      }
    }.bind(this))
  },

  initSort: function() {
    if(this.sortingInitialized) {
      this.initShuffle.destroy();
      this.sortingInitialized = false;
    }
    var productItem;
    var Shuffle = window.Shuffle;

    if(this.$productList.hasClass('product-list--filtered')) {
      productItem = '.product-list__item--filtered:not([style*="display: none"])';
    } else {
      productItem = '.product-list__item';
    }

    this.initShuffle = new Shuffle(this.sortingContainer, { 
        itemSelector: productItem, 
    });

      $('.form-radio-control').on('change', function(e){
          var selectedSort = e.target;
          var options = this._handleSortChange(selectedSort);
          this.initShuffle.sort(options);
      }.bind(this));
      
      this.sortingInitialized = true;
  },

  destroySorting: function(){
    if(this.sortingInitialized) {
      this.initShuffle.destroy();
      this.sortingInitialized = false;
      this.$sortOptions.find('input:checked')[0].checked = false;
      $('#favoriteSort')[0].checked = true;

    }
  },

  sortByPrice: function(element) {
      return element.dataset.sortPrice;
  },
  sortByReview: function(element) {
    return element.dataset.review;
  },

  _handleSortChange: function(element) {
      var value = element.value;
    
      var options;
      if (value === 'priceLTH') {
        options = {
          by: this.sortByPrice,
        };
      } else if (value === 'priceHTL') {
        options = {
          reverse: true,
          by: this.sortByPrice,
        };
      } else if(value === 'reviewLTH') {
        options = {
          by: this.sortByReview,
        };
      } else if(value === 'reviewHTL') {
        options = {
          reverse: true,
          by: this.sortByReview,
        };
      } else {
        options = {};
      }

      return options;
    },

    addReviews: function() {
      var renderOptions = window.pr_render_options;
      var isBVLoaded = window.$BV;
      // Power Reviews 
      if(renderOptions !== undefined) {
        renderOptions.forEach(function(element, index) {
          var elementId = element.components.CategorySnippet;
          var ratingElement = $("#" + elementId)
          var ratingVal = ratingElement.find('.pr-snippet-rating-decimal').text();
          ratingElement.closest('.product-list__item').attr('data-review', ratingVal);
        })
      } else if (isBVLoaded !== undefined) { // Bazaar Voice
        var productItem = $('.product-list__item');
        productItem.each(function(index, element) {
          var ratingVal = $(element).find('.bv_averageRating_component_container .bv_text').text();
          $(element).attr('data-review', ratingVal)
        })
      }
      
      this.addedReviewsData = true;
    }
}

